<template>
    <span>
        <span v-for="(crumb, crumbIndex) in this.visibleCrumbs" :key="crumbIndex" @click.stop="">
            <router-link
                :to="{
                    name: 'organization-management',
                    params: { id: crumb.id },
                }"
                class="small-link"
            >
                {{ crumb.name }}
            </router-link>
            <span class="breadcrumb-divider" v-if="crumbIndex < visibleCrumbs.length - 1">></span>
        </span>
    </span>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    props: {
        organization: {
            type: Object,
            default: () => {},
        },
        breadcrumbs: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        ...mapGetters(['userOrganizationId']),
        visibleCrumbs() {
            let crumbs = [...this.breadcrumbs];
            const userOrganizationIndex = this.breadcrumbs.findIndex(
                crumb => crumb.id === this.userOrganizationId
            );
            const baseOrganizationIndex = this.breadcrumbs.findIndex(
                crumb => crumb.is_base_organization === false
            );
            if (userOrganizationIndex >= 0) {
                crumbs = crumbs.slice(userOrganizationIndex);
            } else if (baseOrganizationIndex >= 0) {
                crumbs = crumbs.slice(baseOrganizationIndex);
            } else {
                crumbs = [];
            }
            if (this.organization && this.organization.id) {
                crumbs.push(this.organization);
            }
            return crumbs;
        },
    },
};
</script>
